import React from 'react';
import type { GlyphProps } from '@atlaskit/icon';

export const AutomationIcon = (props: GlyphProps) => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<g id="Lightning (Beta)">
			<path
				id="Vector 3"
				d="M14 5L10 19"
				stroke={props.primaryColor}
				strokeWidth="2"
				strokeLinecap="round"
			/>
			<path
				id="Vector 4"
				d="M14 5L7 12H17L10 19"
				stroke={props.primaryColor}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</g>
	</svg>
);
